<style lang="scss">
  @import "@/assets/scss/vuexy/components/controlDigital.scss";
</style>
<template>
  <div class="control-digital rounded-full">
    <div class="block text-center mb-2 mt-4">
      <img :src="getImgUrl('nfc_on')" class="h-4 w-4 inline-block mr-3" v-if="nfc"/>
      <img :src="getImgUrl('nfc_off')" class="h-4 w-4 inline-block mr-3" v-else/>
      <img :src="getImgUrl('bluetooth_on')" class="h-4 w-4 inline-block" v-if="bluetooth"/>
      <img :src="getImgUrl('bluetooth_off')" class="h-4 w-4 inline-block" v-else/>
    </div>
    <div class="block text-center mb-4">
      <div class="relative">
        <div class="absolute digital-display">
          <div class="digit">8</div>
          <div class="segment-point">.</div>
          <div class="digit">8</div>
          <div class="segment-point">.</div>
          <div class="digit">8</div>
          <div class="segment-point">.</div>
          <div class="digit">8</div>
        </div>
        <div class="absolute digital-display">
          <div class="digit" :class="{ active: active4 }">{{number4}}</div>
          <div class="segment-point">.</div>
          <div class="digit" :class="{ active: active3 }">{{number3}}</div>
          <div class="segment-point">.</div>
          <div class="digit" :class="{ active: active2 }">{{number2}}</div>
          <div class="segment-point">.</div>
          <div class="digit" :class="{ active: active1}">{{number1}}</div>
        </div>
      </div>
    </div>
    <div class="block text-center container-logo">
      <img :src="getImgUrl('spore_icon')" class="h-4 w-4 inline-block"/>
    </div>
  </div>
</template>
<script>

export default {
  props:{
    value: {
      type: Number,
      default: 0
    },
    nfc:  {
      type: Boolean,
      default: false
    },
    bluetooth: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      number1: 0,
      number2: 0,
      number3: 0,
      number4: 0,
      active1: false,
      active2: false,
      active3: false,
      active4: false,
      strValue: parseInt(this.value).toString()
    }
  },
  methods: {
    getImgUrl (name) {
      const images = require.context('@/assets/images/icons/', false, /\.svg$/)
      return images(`./${  name  }.svg`)
    },
    setValues () {
      this.active1 = false
      this.active2 = false
      this.active3 = false
      this.active4 = false
      let digitIndex = this.strValue.length - 1
      if (digitIndex >= 0) {
        this.number1 = this.getValue(digitIndex)
        this.active1 = true
        if (digitIndex > 0) {
          digitIndex--
          this.number2 = this.getValue(digitIndex)
          this.active2 = true
          if (digitIndex > 0) {
            digitIndex--
            this.number3 = this.getValue(digitIndex)
            this.active3 = true
            if (digitIndex > 0) {
              digitIndex--
              this.number4 = this.getValue(digitIndex)
              this.active4 = true
            }
          }
        }
      }
    },
    getValue (index) {
      if (Number.isInteger(parseInt(this.strValue.charAt(index)))) {
        return parseInt(this.strValue.charAt(index))
      } else {
        return 0
      }
    }
  },
  created () {
    this.setValues()
  }
}
</script>